import makeStyles from '@material-ui/core/styles/makeStyles'
import React from 'react'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(() => ({
  typo: {
    fontWeight: 600,
    marginBottom: '12px',
  },
}))

const Subtitle = ({ children, ...rest }) => (
  <Typography className={useStyles().typo} variant="subtitle1" {...rest}>
    {children}
  </Typography>
)

export default Subtitle
